module.exports = __webpack_public_path__ + "static/media/light-switch-on.bc8d610d.svg";